<template>
  <v-container>
    <h1 class="title">基本資料</h1>
    <v-row>
      <v-col>
        <v-simple-table
          :fixed-header="fixedHeader"
          :height="height"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">項目</th>
                <th class="text-left">明細</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>地址</td>
                <td>{{ data.address }}</td>
              </tr>
              <tr>
                <td>客戶名字</td>
                <td>{{ data.clientName }}</td>
              </tr>
              <tr>
                <td>電話</td>
                <td>{{ data.phone }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ data.email }}</td>
              </tr>
              <tr>
                <td>工地</td>
                <td>{{ data.site }}</td>
              </tr>
              <tr>
                <td>描述</td>
                <td>{{ data.description }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <h1 class="title">增加修改紀錄</h1>
    <v-row>
      <v-col>
        <v-text-field
          :counter="10"
          v-model="item.currentUser"
          :rules="[v => !!v || '填寫人必須填寫']"
          label="填寫人"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          :counter="10"
          v-model="item.description"
          :rules="[v => !!v || '描述必須填寫']"
          label="描述"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <image-uploader
          :debug="1"
          :quality="0.7"
          :autoRotate="true"
          outputFormat="string"
          :preview="true"
          :className="[' file-button', { 'fileinput--loaded': hasImage }]"
          accept="image/*"
          doNotResize="['gif', 'svg']"
          @input="setImage"
        ></image-uploader>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <VueSignaturePad
          id="signature"
          width="100%"
          height="300px"
          ref="signaturePad"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-end">
        <v-btn
          outlined
          color="cyan darken-2"
          @click="$router.go(-1)"
        >取消</v-btn>

        <v-btn
          class="ml-auto"
          outlined
          color="blue-grey "
          @click="undo"
        >重新簽名</v-btn>
        <v-btn
          depressed
          color="cyan darken-2 white--text ml-2"
          @click="onSubmit"
        >送出</v-btn>
      </v-col>
    </v-row>
    <v-row
      mt-5
      v-if="loading"
    >
      <v-col class="d-flex justify-end">
        <v-progress-circular
          indeterminate
          color="blue-grey"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection } from "@/db";
import firebase from "firebase";
export default {
  name: "NewRepairItem",
  data: () => ({
    loading: false,
    fixedHeader: false,
    height: 300,
    signature_base64: "",
    data: {
      id: "",
      site: "",
      phone: "",
      description: "",
      address: "",
      clientName: "",
      problemType: "",
      email: ""
    },
    item: {
      currentUser: "",
      date: new Date(),
      description: "",

      images: []
    },
    siteImageType: "",
    hasImage: false,
    image: ""
  }),
  created() {
    // eslint-disable-next-line
    const vm = this;
    repairsCollection
      .doc(this.$route.params.repair_id)
      .get()
      .then(doc => {
        vm.data = {
          ...vm.basic,
          ...doc.data(),
          id: this.$route.params.repair_id
        };
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  methods: {
    undo() {
      this.$refs.signaturePad.clearSignature();
    },
    setImage: function(output) {
      this.hasImage = true;
      this.image = output;
      this.siteImageType = output.substring(5, output.indexOf(";base64"));
    },
    onSubmit() {
      this.loading = true;
      this.signature_base64 = this.$refs.signaturePad.saveSignature().data;
      if (this.hasImage == false && !this.signature_base64) {
        this.updateFireStoreData();
      } else {
        const imgArr = [];

        if (this.image) {
          imgArr.push({
            image: this.image,
            imageType: this.siteImageType,
            name: "repair"
          });
        }
        if (this.signature_base64) {
          const signatureImgType = this.signature_base64.substring(
            5,
            this.signature_base64.indexOf(";base64")
          );

          imgArr.push({
            image: this.signature_base64.replace(
              `data:${signatureImgType};base64,`,
              ""
            ),
            imageType: signatureImgType,
            name: "repair_signature"
          });
        }

        Promise.all(
          imgArr.map(
            async (image, index) => await this.putStorageItem(image, index)
          )
        )
          .then(data => {
            data.forEach(image => {
              const newItem = {
                imageUrl: image[0].downloadURL,
                filePath: image[1]
              };
              this.item.images.push(newItem);
            }, this);
            repairsCollection
              .doc(this.$route.params.repair_id)
              .update({
                repair_items: firebase.firestore.FieldValue.arrayUnion(
                  this.item
                )
              })
              // eslint-disable-next-line no-unused-vars
              .then(docRef => {
                this.$router.push("/");
              })
              // eslint-disable-next-line no-console
              .catch(error => console.log(error));
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log(`Some failed: `, error);
          });
      }
    },
    // eslint-disable-next-line no-unused-vars
    putStorageItem(data, index) {
      // the return value will be a Promise
      const { image, imageType, name } = data;
      const storageRef = firebase
        .storage()
        .ref(`/${this.$route.params.repair_id}/`);
      const file = image.replace(`data:${imageType};base64,`, "");
      // 20190318
      const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      const fileName = `${
        this.$route.params.repair_id
      }_${currentDate}_${Math.floor(Math.random() * 90000) + 10000}_${name}`;
      return new Promise((resolve, reject) => {
        storageRef
          .child(fileName)
          .putString(file, "base64", { contentType: imageType })
          .then(snapshot => {
            snapshot.ref.getDownloadURL().then(function(downloadURL) {
              const data = { name, downloadURL };
              resolve([data, fileName]);
            });
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.log("One failed:", error);
            // eslint-disable-next-line no-undef
            reject(err);
          });
      });
    },
    updateFireStoreData() {
      repairsCollection
        .doc(this.data.id)
        .update({
          repair_items: firebase.firestore.FieldValue.arrayUnion(this.item)
        })
        .then(docRef => {
          console.log("docRef", docRef);
          this.$router.push(`/show/${this.$route.params.repair_id}`);
        })
        .catch(error => console.log(error));
    },
    storeImgToFireStore() {
      // eslint-disable-next-line
      const vm = this;
      // Folder Name
      const storageRef = firebase
        .storage()
        .ref(`/${this.$route.params.repair_id}/`);
      const file = this.image.replace(
        `data:${this.item.siteImageType};base64,`,
        ""
      );
      // 20190318
      const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      const fileName = `${
        this.$route.params.repair_id
      }_${currentDate}_${Math.floor(Math.random() * 90000) + 10000}_repair`;

      this.item.filePath = fileName;
      return new Promise((resolve, reject) => {
        storageRef
          .child(fileName)
          .putString(file, "base64", { contentType: this.item.siteImageType })
          .then(snapshot => {
            snapshot.ref.getDownloadURL().then(function(downloadURL) {
              const data = { name, downloadURL };
              resolve(data);
            });
          })
          .catch(error => {
            console.log("One failed:", error);
            reject(error);
          });
      });
    }
  }
};
</script>
<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>
